// extracted by mini-css-extract-plugin
export default {"bar":"SubmitBar_bar__3kC2Z","note":"SubmitBar_note__FwZ-o","actions":"SubmitBar_actions__GJaZF"};